export default __webpack_public_path__ + "static/media/Heaven's Gung Si.a72af56f.jpg";